module.exports = __webpack_public_path__ + "img/wechat.681812cc.png";